﻿{
  "en": {
    "Home.goHome": "Go to the home page",
    "Search.searchOptoma": "Search Optoma",
    "Search.searchResults": "Search results",
    "Search.seeMoreResults": "See more results"
  },
  "fr": {
    "Home.goHome": "Aller à la page d'accueil",
    "Search.searchOptoma": "Recherche",
    "Search.searchResults": "Résultats de la recherche",
    "Search.seeMoreResults": "Voir plus de résultats"
  },
  "es": {
    "Home.goHome": "Ir a la página de inicio",
    "Search.searchOptoma": "Buscar Optoma",
    "Search.searchResults": "Resultados de la búsqueda",
    "Search.seeMoreResults": "Ver más resultados"
  },
  "de": {
      "Home.goHome": "Zur Startseite",
      "Search.searchOptoma": "Optoma suchen",
      "Search.searchResults": "Suchergebnisse",
      "Search.seeMoreResults": "Mehr Ergebnisse anzeigen"
  },
  "it": {
      "Home.goHome": "Vai alla pagina iniziale",
      "Search.searchOptoma": "Cerca Optoma",
      "Search.searchResults": "Risultati della ricerca",
      "Search.seeMoreResults": "Vedi altri risultati"
  },
  "nl": {
      "Home.goHome": "Ga naar de startpagina",
      "Search.searchOptoma": "Zoek Optoma",
      "Search.searchResults": "Zoekresultaten",
      "Search.seeMoreResults": "Meer resultaten bekijken"
  },
  "pl": {
      "Home.goHome": "Przejdź do strony głównej",
      "Search.searchOptoma": "Wyszukaj Optoma",
      "Search.searchResults": "Wyniki wyszukiwania",
      "Search.seeMoreResults": "Zobacz więcej wyników"
  },
  "ru": { 
    "Home.goHome": "Перейти на главную страницу",
    "Search.searchOptoma": "Поиск Optoma",
    "Search.searchResults": "Результаты поиска",
    "Search.seeMoreResults": "Показать больше результатов"
  },
  "es-MX": {
    "Home.goHome": "Ir a la página de inicio",
    "Search.searchOptoma": "Buscar Optoma",
    "Search.searchResults": "Resultados de la búsqueda",
    "Search.seeMoreResults": "Ver más resultados"
  },
  "pt-BR": {
    "Home.goHome": "Ir para a página inicial",
    "Search.searchOptoma": "Pesquisar Optoma",
    "Search.searchResults": "Resultados da pesquisa",
    "Search.seeMoreResults": "Ver mais resultados"
  },
  "zh": {
    "Home.goHome": "转到主页",
    "Search.searchOptoma": "搜索Optoma",
    "Search.searchResults": "搜索结果",
    "Search.seeMoreResults": "查看更多结果"
  },
  "zh-TW": {
    "Home.goHome": "轉到主頁",
    "Search.searchOptoma": "搜尋Optoma",
    "Search.searchResults": "搜尋結果",
    "Search.seeMoreResults": "查看更多結果"
  },
  "ja-JP": {
    "Home.goHome": "ホームページへ",
    "Search.searchOptoma": "Optomaを検索",
    "Search.searchResults": "検索結果",
    "Search.seeMoreResults": "さらに表示"
  },
  "ko-KR": {
    "Home.goHome": "홈페이지로 이동",
    "Search.searchOptoma": "Optoma 검색",
    "Search.searchResults": "검색 결과",
    "Search.seeMoreResults": "더 보기"
  }
}